import { Link } from "react-router-dom";
import { Lock, Users } from "lucide-react";

export default function CommunityLocked({ me }) {
  const unpaid = me.code === 402;
  return (
    <div className="max-w-xl brutal-border bg-[#141414] p-8 sm:p-10" data-testid="community-locked">
      {unpaid ? <Users size={34} className="mb-4 text-[#FFD600]" /> : <Lock size={34} className="mb-4 text-muted-foreground" />}
      <h1 className="font-heading font-black text-3xl leading-tight">{unpaid ? "Join the Carrier Community." : "Community unavailable."}</h1>
      <p className="text-muted-foreground mt-3" data-testid="community-locked-reason">
        {unpaid ? "Members with any paid plan can chat with other carriers, share resources and swap experiences in topic rooms." : me.reason}
      </p>
      {unpaid && (
        <Link to="/pricing" data-testid="community-locked-pricing" className="mt-6 inline-flex min-h-[44px] items-center px-5 cta-primary font-mono-label text-xs">
          See plans
        </Link>
      )}
    </div>
  );
}
